export default __webpack_public_path__ + "static/media/azaelindia.807090f7.jpg";